import { makeVar } from '@apollo/client';

export const companyShortNameVar = makeVar<string>('NNC');
